/** Non-breaking space: keeps "18 900 $" on one line in Telegram and in the Mini App. */
export const NBSP = ' ';
/** Typographic minus used for negative amounts. */
export const MINUS = '−';

/** Groups digits by thousands with non-breaking spaces: 148000 → "148 000". */
export function groupThousands(value: number): string {
  const abs = Math.abs(Math.trunc(value));
  return abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
}
